/**
 * After the product welcome tour, walk T&A sidebar links once when
 * timekeeping.module is available (first login after the module is enabled).
 */

import { useAuth } from "../../contexts/AuthContext";
import { useOnboardingOptional } from "./OnboardingContext";
import { useModuleTourAutoStart } from "./useModuleTourAutoStart";
import { PEOPLE_TA_NAV_TOUR_ID } from "./tours";

export default function TaNavTourBootstrap() {
  const { hasPermission } = useAuth();
  const onboarding = useOnboardingOptional();
  const ready = Boolean(hasPermission?.("timekeeping.module"));

  useModuleTourAutoStart(onboarding, PEOPLE_TA_NAV_TOUR_ID, {
    ready,
    waitForWelcome: true,
    delayMs: 900,
  });

  return null;
}
